import React from 'react';
// import { Redirect, useHistory } from 'react-router-dom';
import { Row, Col , Spin} from 'antd';
import { HeaderWithoutAuth, FooterWithoutAuth, LoadingGif } from 'components';

import LoginForm from './login-form';
import FastLogin from './fast-login';
import LoginBackground from './login-background';

import './login.less';
import 'styles/global.less';
import { useSelector} from 'react-redux';
import { MetaTags } from 'react-meta-tags';

export default function Login() {
  
  const {loading} = useSelector(state=>state.loader);

  return (
    
    <div className="login-page">
    <MetaTags> 
    <title>Toplu Mesaj Paneline Giriş | Turkcell Mesaj Üssü</title>
            <meta name="description" content="Mesaj Üssü toplu SMS ve ZİM programına üye olanlar girişlerini bu sayfadan yapabilirler. Üye değilseniz hızlıca Turkcell numaranızı girip kayıt olabilirsiniz." />
          </MetaTags>
          <Spin  spinning={loading} style={{ margin: '0 auto' }}   indicator={<LoadingGif></LoadingGif>}  >
      <LoginBackground />
      <HeaderWithoutAuth white={true} />
      
      <Row justify="center">
        <Col xs={24} sm={24} md={16} lg={16} xl={16}>
          <Row className="form-section" justify="center">
            <Col
              className="form-section-item login-form"
              xs={24}
              sm={24}
              md={24}
              lg={12}
              xl={12}
            >
              <LoginForm />
            </Col>
            <Col
              className="form-section-item fast-login"
              xs={24}
              sm={24}
              md={24}
              lg={12}
              xl={12}
            >
              <FastLogin />
            </Col>
          </Row>
        </Col>
      </Row></Spin> 
      <FooterWithoutAuth />
    </div>    
  );
}
